/**
 *  ALT Labels
 */
import ImgNotFound from "../assets/images/probrain_notfound_wide.png";
export const ALT_LOGO = "Logo ProBrain";
export const IMG_NOT_FOUND = ImgNotFound;
export const LOGO = ImgNotFound;
